/**
 * Formatage uniforme des dates au format français jj/mm/aaaa
 * Utilisé partout dans l'application CMT Health Platform
 */

/**
 * Formate une date au format DD/MM/YYYY.
 * Accepte :
 *   - une chaîne ISO "YYYY-MM-DD" ou "YYYY-MM-DDTHH:mm:ss..."
 *   - un objet Date
 * @param {string|Date|null|undefined} input
 * @param {string} fallback - valeur retournée si input invalide
 * @returns {string}
 */
export const formatDate = (input, fallback = '—') => {
  if (!input) return fallback;
  try {
    let d;
    if (input instanceof Date) {
      d = input;
    } else if (typeof input === 'string') {
      // Cas simple "YYYY-MM-DD"
      const m = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) {
        return `${m[3]}/${m[2]}/${m[1]}`;
      }
      d = new Date(input);
    } else {
      return fallback;
    }
    if (isNaN(d.getTime())) return fallback;
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}/${mm}/${yyyy}`;
  } catch (e) {
    return fallback;
  }
};

/**
 * Formate une date+heure au format "DD/MM/YYYY à HHhMM".
 * @param {string|Date|null|undefined} input
 * @param {string} fallback
 * @returns {string}
 */
export const formatDateTime = (input, fallback = '—') => {
  if (!input) return fallback;
  try {
    const d = input instanceof Date ? input : new Date(input);
    if (isNaN(d.getTime())) return fallback;
    const dateStr = formatDate(d);
    const hh = String(d.getHours()).padStart(2, '0');
    const mm = String(d.getMinutes()).padStart(2, '0');
    return `${dateStr} à ${hh}h${mm}`;
  } catch (e) {
    return fallback;
  }
};

/**
 * Combine une date "YYYY-MM-DD" et une heure "HH:MM" au format "DD/MM/YYYY à HHhMM".
 * @param {string} dateStr
 * @param {string} timeStr
 * @returns {string}
 */
export const formatDateAndTime = (dateStr, timeStr) => {
  const date = formatDate(dateStr);
  if (!timeStr) return date;
  const clean = String(timeStr).replace(':', 'h');
  return `${date} à ${clean}`;
};
